import { BulkDiscountClient, CouponClient, DSODiscountClient } from 'types';
import { Styled } from './';
import { MdLocalOffer } from 'react-icons/md';
import { PromoDescription } from './ProductDetails.styles';
import { useI18n } from 'contexts/i18n';

const AvailableOffers = ({
  bulkDiscount,
  coupon,
  dsoDiscount,
}: {
  bulkDiscount?: BulkDiscountClient | void;
  coupon?: CouponClient | void;
  dsoDiscount?: DSODiscountClient | void;
}) => {
  const hasOffers = Boolean(bulkDiscount || coupon || dsoDiscount);
  // Count non-stackable offers to determine if "best discount" note is needed.
  // Stackable coupons are excluded — they combine with other discounts.
  const nonStackableOfferCount =
    (bulkDiscount ? 1 : 0) +
    (dsoDiscount ? 1 : 0) +
    (coupon && !coupon.stackable ? 1 : 0);
  const i18n = useI18n();

  if (!hasOffers) {
    return null;
  }

  const tagStyle: React.CSSProperties = {
    color: 'green',
    marginRight: 6,
    verticalAlign: 'middle',
  };

  const OfferItem = ({
    name,
    description,
  }: {
    name?: string;
    description?: string;
  }) => {
    if (!name && !description) return null;

    return (
      <Styled.DiscountItem>
        <div>
          <div style={{ fontWeight: 500 }}>
            <MdLocalOffer style={tagStyle} />
            <span
              dangerouslySetInnerHTML={{
                __html: name || '',
              }}
            />
          </div>
          <PromoDescription
            dangerouslySetInnerHTML={{
              __html: description || '',
            }}
          />
        </div>
      </Styled.DiscountItem>
    );
  };

  return (
    <div>
      <Styled.DiscountHeader>{i18n['Available offers']}</Styled.DiscountHeader>
      <OfferItem name={coupon?.name} description={coupon?.description} />
      <OfferItem
        name={bulkDiscount?.title}
        description={bulkDiscount?.description}
      />

      <OfferItem
        name={dsoDiscount?.title}
        description={dsoDiscount?.description}
      />
      {nonStackableOfferCount > 1 && (
        <Styled.DiscountNote>
          {
            i18n[
              '*This product has multiple discounts. We’ll automatically apply the best available discount based on your purchase quantity.'
            ]
          }
        </Styled.DiscountNote>
      )}
    </div>
  );
};

export default AvailableOffers;
